import mixpanel from "mixpanel-browser";

type OpenGallerySource = "Floorplan button" | "Presence list button";

export function trackOpenGallery(source: OpenGallerySource) {
  try {
    mixpanel.track("Open gallery");
  } catch (e) {}
}
